import { createElement, forwardRef } from "react";
import { cn } from "@synthesis/shared-utils";
//#region src/DatePicker/DatePicker/DatePicker.elements.ts
const Main = forwardRef(({ full, className, ...props }, ref) => createElement("div", {
	ref,
	className: cn("relative inline-flex flex-col text-left", full && "w-full", className),
	...props
}));
Main.displayName = "DatePickerMain";
const Label = ({ className, ...props }) => createElement("p", {
	className: cn("mb-2", className),
	...props
});
const Container = forwardRef(({ isErrors, isReadonly, isValid, size, className, ...props }, ref) => createElement("div", {
	ref,
	className: cn("bg-neutrals-95 hover:bg-neutrals-90 focus-within:outline-system-info-50 relative flex items-center gap-2 rounded-xl border-2 border-solid border-transparent pl-[0.625rem] pr-3 text-sm font-normal outline outline-2 outline-transparent transition-colors", !isReadonly && isErrors && "border-system-error-50 focus-within:outline-system-error-70", !isReadonly && isValid && "border-system-success-50 focus-within:outline-system-success-70", isReadonly && "bg-neutrals-90 cursor-default border-transparent focus-within:outline-transparent", size === "sm" && "py-1", size === "md" && "rounded-[0.875rem] py-[0.375rem] text-base", size !== "sm" && size !== "md" && "rounded-[0.875rem] py-[0.625rem] text-base", className),
	...props
}));
Container.displayName = "DatePickerContainer";
//#endregion
export { Container, Label, Main };

//# sourceMappingURL=DatePicker.elements.js.map